export const RCM_DOWNLOAD_LINK = process.env.REACT_APP_RCM_DOWNLOAD;
